import { lazy } from 'react';
import { isChunkLoadError, recoverFromChunkError } from './chunkRecovery';

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const lazyWithRetry = (importFn, retries = 2) =>
  lazy(async () => {
    let lastError;

    for (let attempt = 0; attempt <= retries; attempt += 1) {
      try {
        return await importFn();
      } catch (error) {
        lastError = error;
        if (!isChunkLoadError(error)) throw error;
        if (attempt < retries) {
          await sleep(250 * (attempt + 1));
          continue;
        }
        if (recoverFromChunkError(error)) {
          await new Promise(() => {});
        }
        throw error;
      }
    }

    throw lastError;
  });

export { lazyWithRetry as lazy };
